<div class="productAdd seedAddProduct d-flex">
  <div>
    <h3>Add Product Name/Package Size to the order</h3>
    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-10 col-lg-11 smallPadRgt0">
          <div class="row search-box-outer">
            <div class="col-4 col-md-3 padding-r0 border-right padding-l0">
              <div class="brand-dropdown material-select d-none d-md-block">
                <ng-select name="ddlProductSearch"
                           [items]="['Product Name']"
                           [(ngModel)]="defaultSearchType"
                           [disabled]="true"
                           [searchable]="false"
                           [clearable]="false"
                           data-testid="ddl-brandPackageSizeKey-search">

                </ng-select>
              </div>
            </div>
            <div class="col-8 col-md-9 padding-l0 padding-r0">
              <div class="material-select sales-search">
                <div class="row">
                  <div class="col-md-6 pr-0" #productSearch>

                    <div class="search-box-outer rightBorder">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <span class="updateFontStyle">
                            <input matInput
                                   placeholder="Minimum 3 chars required to search..."
                                   [matAutocomplete]="productNameAuto"
                                   [formControl]="productNameCtrl"
                                   (keyup.enter)="onProductNameEnter()">
                            <mat-autocomplete #productNameAuto="matAutocomplete"
                                              (optionSelected)="onProductNameSelected($event)">
                              <mat-option [ngClass]="{'hide-autocomplete': !showProductNameAutocomplete}"
                                          *ngFor="let name of filteredProductNames | async"
                                          [value]="name">
                                <span>{{ name }}</span>
                              </mat-option>
                            </mat-autocomplete>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 pl-0">
                    <ng-select #productPackageSearch name="ddlproductSearch"
                               [items]="packageSizeList"
                               bindLabel="packageSize"
                               bindValue="packageSizeID"
                               placeholder="Package Size"
                               class="custom-select-grower"
                               [multiple]="false"
                               [(ngModel)]="packageSize"
                               [virtualScroll]="true"
                               [closeOnSelect]="true"
                               [clearable]="true"
                               [disabled]="!packageSizeList || packageSizeList.length === 0"
                               (change)="onPackageSizeChange()">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="dropdown-template">
                          <p>{{item.packageSize}}</p>
                        </div>
                      </ng-template>
                      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                        <div class="ng-option disabled">
                          No data found for "{{searchTerm}}"
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>


        <div class="col-md-2 col-lg-1 col-sm-12 search-btn-outer text-center padding-sm-l15 padding-sm-r0">
          <div class="search-btn">
            <button mat-raised-button class="btns wide-sm-100 margin-t12 margin-sm-t10" color="primary" (click)="getProducts()" [disabled]="isDisableSearchBtn" data-testid="btn-orderfilter-search">Search</button>
          </div>
        </div>
      </div>
      <div class="row chips-sec" *ngIf="filterValueList.length > 0">
        <div class="col-sm-9 selected-chip">
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList" [ngClass]="{ 'readonly-filter': isDefaultFilter(filterValue) }">
              {{filterValue}}
              <a *ngIf="!isDefaultFilter(filterValue)"
                 href="Javascript:void(0);"
                 (click)="clearFilter(filterValue)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
        <div class="col-sm-3 text-right padding-r20" *ngIf="filterValueList.length > 0">
          <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
        </div>
      </div>
    </div>
    <div class="reconcile-slider-body">
      <div class="reconcile-slider-table-area">
        <div class="row">
          <div class="col-md-12">
            <div class="tableContainer table-mobile-landing">
              <table mat-table #productsTable [dataSource]="productDataSource" class="matTables">
                <!-- Position Column -->
                <ng-container matColumnDef="SeedAvailability">
                  <th mat-header-cell *matHeaderCellDef class="text-center" title="Availability">Avail.</th>
                  <td mat-cell *matCellDef="let element" class="available-block text-center">
                    <div class="mobileText">Avail.</div>
                    <span class="seed-avail">
                      {{element.seedAvailability | number}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="NetBEU">
                  <th mat-header-cell *matHeaderCellDef class="text-center" title="Dealer Order">DO</th>
                  <td mat-cell *matCellDef="let element" class="available-block text-center">
                    <div class="mobileText">DO</div>
                    <span class="seed-avail">
                      {{element.netBEU | number}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="DealerBucket">
                  <th mat-header-cell *matHeaderCellDef class="text-center" title="My Dealer Bucket"> MDB </th>
                  <td mat-cell *matCellDef="let element" class="available-block text-center">
                    <div class="mobileText">MDB</div>
                    <span>
                      <span class="seed-avail" *ngIf="element.myDealerBucket>=0">{{commonService.getFormatedNumber(element.myDealerBucket) | number}}</span>
                      <span class="seed-avail" *ngIf="element.myDealerBucket<0">({{commonService.getFormatedNumber(element.myDealerBucket | positiveValue) | number}})</span>
                    </span>
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="Product Name">
                  <th mat-header-cell *matHeaderCellDef class="productNameBlock">Hybrid Variety </th>
                  <td mat-cell *matCellDef="let element" class="order-info d-sm-block d-md-table-cell product-line" id="td-ProductDetail" [attr.data-testid]="'hybrid-variety-product-name-' + element.HybridVarietyProductItemId">
                    <p class="d-block d-md-none padding-l5">Product</p>
                    <span [attr.data-testid]="'hybrid-variety-product-item-number-' + element.HybridVarietyProductItemNumber">
                      <p><a>{{element.brand}}</a> </p>
                      <!--<p class="grower-name">
                        <a>
                          {{element.itemDescription}}
                        </a>
                      </p>-->
                    </span>
                    <p *ngIf="element.seedNonReturnable" class="nonReturnable"> <a>*NON-RETURNABLE </a></p>
                  </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="Pack Size">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Package Size </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
                    <span class="oval-shape" [ngClass]="{'pack-size': (element.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" [attr.data-testid]="'hybrid-variety-product-package-size-' + element.HybridVarietyProductPackageSize">
                      {{element.packageSize}}
                    </span>
                  </td>
                </ng-container>


                <!-- Units -->
                <ng-container matColumnDef="Units">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Units </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
                    <div class="d-flex align-items-center justify-content-center" *ngIf="!element.isProductDeactivated">
                      <button (click)="geuValueChange('decrease',element);" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.brandPackageSizeKey">
                        -
                      </button>
                      <input #unitsInput class="geu-txt decimal-txt unitsText"
                             id="txtUnits"
                             type="text"
                             [(ngModel)]="element.reservationUnits"
                             [ngClass]="{'invalid-txt': (element.reservationUnits==0 && element.growerOrderItemId==0)}"
                             maxlength="9"
                             appThreeDigitDecimaNumber
                             autocomplete="off"
                             [disabled]="element.isProductDeactivated" (blur)="geuTextChange(element)"
                             [attr.data-testid]="'qty-' + element.brandPackageSizeKey" />
                      <button *ngIf="!element.isProductDeactivated"
                              (click)="geuValueChange('increase',element);" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.brandPackageSizeKey">
                        +
                      </button>

                    </div>
                    <div *ngIf="element.isProductDeactivated" class="unitsText disabledInputText text-center">
                      {{commonService.getFormatedNumber(element.reservationUnits) | number}}
                    </div>
                  </td>
                </ng-container>


                <!-- delivery date -->
                <ng-container matColumnDef="Delivery Date">
                  <th mat-header-cell *matHeaderCellDef class="text-center"> Desired Delivery Date </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="date-input-wrapper m-auto">
                        <mat-form-field class="w-100" >
                          <input matInput class="delivery-date-input" [readonly]="element.isProductDeactivated"
                                 [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter"
                                 [(ngModel)]="element.desiredDeliveryDate" (dateChange)="syncSelectedItem(element)" disabled>
                          <mat-datepicker-toggle [id]="'ddl-date-picker_'+i" matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker [disabled]="element.isProductDeactivated"></mat-datepicker>
                        </mat-form-field>

                      </div>
                    </div>                   
                  </td>
                </ng-container>
          <ng-container matColumnDef="Product Line">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Product Line </th>
            <td mat-cell *matCellDef="let element" class="product-line text-center d-none d-md-table-cell" [attr.data-testid]="'hybrid-variety-product-line-' + element.HybridVarietyProductItemNumber">
              <div class="checkBoxOuterBg">
                <div class="chkboxOuter">
                  <i class="fas fa-check checkShowHide"></i>
                  <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && (element.isProductDeactivated == false || (element.deactivationType == null || page == 'dealerOrder' || element.deactivationType.trim().toLowerCase() != 'suspend'))"></mat-checkbox>
                </div>
              </div>
              <span>
                {{element.productLine}}
              </span>
                    <div class="checkBoxOuterBg margin-t10">
                        <div class="chkboxOuter">
                          <i class="fas fa-check checkShowHide" (click)="removeSelectedRow(element)"></i>
                          <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.isProductSelected" *ngIf="element.isProductSelected && (!element.isProductDeactivated)"></mat-checkbox>
                        </div>
                    </div>

                    <div class="unavailableMsg" *ngIf="element.isProductDeactivated">
                      <div id="main_{{element.itemNumber}}">
                        <div class="unavail-content" id="sub_{{element.itemNumber}}">
                          <h4>This product and package size combination is currently unavailable for ordering.</h4>
                        </div>
                      </div>
                    </div>
              </td>
          </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'active': row.isProductSelected}"></tr>
              </table>
              <!--<mat-paginator #productPaginator [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row add-order-sec margin-l0 margin-r0 justify-content-between">
       <button mat-raised-button class="btns account-sidebar__btn" color="primary" [disabled]="selectedProductList.length <=0 " (click)="AddProducts()">Add to Order</button>
      <div>PRODUCTS SELECTED: <span class="count">{{selectedProductList.length}}</span></div>
    </div>
  </div>
</div>
